import React, { useState, useEffect } from "react";
import SampleTestSearch from "./SampleTestSearch";
import BarcodeSampleTestSearch from "./BarcodeSampleTestSearch";
import { fetchJson } from "../../lib/Fetching";
import Samples from "./Samples";
import Link from "../Link";
import ResultsContext, { useResultsContext } from "./contexts/ResultsContext";
import { Provider as SelectedTestsProvider } from "./contexts/SelectedTestsContext";
import { Provider as TestResultsProvider } from "./contexts/TestResultsContext";

import SamplesResults from "./SamplesResults";

export default function SampleTestSearchContainer({
  laboratory_company_id,
  sample_id,
  aliquot_id,
  clearDates,
  clientView = true,
  company_id,
  defaultSearchParameters = {},
  initialView = "standard_search",
  hideNavigation = false,
  allowInitialSearch = true,
}) {
  const [searchParameters, setSearchParameters] = useState(defaultSearchParameters);
  const [searchCallback, setSearchCallback] = useState(() => {});
  const [route, setRoute] = useState(initialView);
  const [allowSearch, setAllowSearch] = useState(allowInitialSearch);

  const onSearch = (params, callback) => {
    setSearchParameters(params);
    setAllowSearch(true);
    setSearchCallback(() => callback);
  };

  const reset = () => {
    setSearchCallback(() => {});
    setSearchParameters(null);
  };

  const viewStandardSearch = () => {
    reset();
    setRoute("standard_search");
  };

  const viewBarcodeSearch = () => {
    reset();
    setRoute("barcode_search");
  };

  var path = window.location.pathname + window.location.search;

  return (
    <div>
      {!clientView &&
        !hideNavigation && (
          <p>
            <Link onClick={viewStandardSearch} style={{ marginRight: 20 }}>
              Standard Results Search
            </Link>
            <Link onClick={viewBarcodeSearch} style={{marginRight: 20 }}>Barcode Search</Link>
            <select className="pull-right" onChange={e => window.location = e.target.value} value={path} style={{paddingTop: 5, paddingBottom: 5}}>
              <option value="/sample_testing/sample_tests">Select Microbiology Preset</option>
              <option value="/sample_testing/sample_tests?preset=food_ready_for_approval">Food Ready For Approval</option>
              <option value="/sample_testing/sample_tests?preset=swabs_and_water_caveats_ready_for_approval">Swabs & Water, Require Caveats, Ready For Approval</option>
              <option value="/sample_testing/sample_tests?preset=swabs_and_water_no_caveats_ready_for_approval">Swabs & Water, No Caveats, Ready For Approval</option>
            </select>
          </p>
        )}
      {route == "hidden_search" && (
        <p style={{ marginTop: 10 }}>
          <Link onClick={() => setRoute("standard_search")}>
            <i className="fa fa-caret-down" />
            &nbsp;&nbsp; Show Advanced Result Search
          </Link>
        </p>
      )}
      {route == "standard_search" && (
        <SampleTestSearch
          onSearch={onSearch}
          initialSampleId={sample_id}
          initialAliquotId={aliquot_id}
          laboratory_company_id={laboratory_company_id}
          clearDates={clearDates}
          clientView={clientView}
          companyId={company_id}
          fixedSearchParameters={defaultSearchParameters}
        />
      )}
      {route == "barcode_search" && (
        <BarcodeSampleTestSearch onSearch={onSearch} clientView={clientView} reset={reset} />
      )}
      {
        allowSearch &&
        <SamplesResults
          searchParams={searchParameters}
          clientView={clientView}
          simpleSampleView={false}
          searchCallback={searchCallback}
        />
      }
    </div>
  );
}
